import { Card, InlineGrid, Link, Text } from "@shopify/polaris";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const StoreDetails = () => {
  const [storeData, setStoreData] = useState({
    primaryDomain: "",
    currencyCode: "",
  });
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const paramValue = urlParams.get("shop");
    const fetchStoreData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/shopify/get_store_data?shop=${paramValue}`
        );
        const data = await response.json();
        if (data.status && data.data.shop) {
          setStoreData({
            primaryDomain: data.data.shop.primaryDomain.url,
            currencyCode: data.data.shop.currencyCode,
          });
        }
      } catch (error) {
        console.error("Error fetching store data:", error);
      }
    };

    fetchStoreData();
  }, []);

  return (
    <Card>
      <Text variant="headingMd" as="h6">
        Store Details
      </Text>
      <InlineGrid gap="400" columns={["oneThird", "twoThirds"]}>
        <div
          style={{
            width: "100%",
            textAlign: "right",
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            rowGap: "5px",
          }}
        >
          <Text variant="bodyMd" fontWeight="medium" as="p">
            Your Primary Domain
          </Text>
          <Text variant="bodyMd" fontWeight="medium" as="p">
            Your Store Currency
          </Text>
        </div>
        <div
          style={{
            width: "100%",
            marginTop: "10px",
            display: "flex",
            flexDirection: "column",
            rowGap: "6px",
          }}
        >
          <Text variant="bodyMd" as="p">
            <Link url={storeData.primaryDomain}>{storeData.primaryDomain}</Link>
          </Text>
          <Text variant="bodyMd" fontWeight="semibold" as="p">
            {storeData.currencyCode}
            <Text variant="bodyMd" as="p">
              Your Product Feed will be submitted to a particular marketing
              platform using the same currency as your Shopify store's default
              currency.{" "}
              <Link url={storeData.primaryDomain + "/admin/settings/general"} target="_blank">
                Change your currency from your Store settings.
              </Link>
            </Text>
          </Text>
        </div>
      </InlineGrid>
    </Card>
  );
};

export default StoreDetails;
